/**
 * Pending Actions Manager
 *
 * Handles queueing of user actions (mark, unmark, skip) while habits are being fetched
 * to prevent data loss when the fetch response overwrites local state.
 */

import { markSuccess, unmarkSuccess, skipSuccess } from "actions/dates";
import { updateStreak } from "actions/stats";

// Internal state - not using Redux to avoid complications
let isFetchingHabits = false;
let pendingActions = [];

/**
 * Set the fetching state
 */
export function setFetchingHabits(fetching) {
  isFetchingHabits = fetching;
  console.log("setFetchingHabits", fetching);
}

/**
 * Check if currently fetching habits
 */
export function isFetching() {
  return isFetchingHabits;
}

/**
 * Add an action to the pending queue if currently fetching
 * Actions are always executed immediately, but also queued if fetching
 * so they can be replayed after fetch completes
 * @param {Object} action - The action to queue
 */
export function addPendingAction(action) {
  if (isFetchingHabits) {
    pendingActions.push(action);
    console.log("pendingActions after", action.action, ":", pendingActions);
  }
}

/**
 * Get a copy of current pending actions
 */
export function getPendingActions() {
  return [...pendingActions];
}

/**
 * Clear all pending actions
 */
export function clearPendingActions() {
  pendingActions = [];
}

/**
 * Process all pending actions and clear the queue
 * @param {Function} dispatch - Redux dispatch function
 * @param {Function} getState - Redux getState function
 */
export function processPendingActions(dispatch, getState) {
  const actions = getPendingActions();
  console.log("processPendingActions:", actions);

  if (actions.length === 0) {
    return;
  }

  const state = getState();

  for (const pendingAction of actions) {
    const { action, date, habit_id } = pendingAction;
    const habit = state.habitsEntities[habit_id];
    const habitDates = state.dates[habit_id];

    switch (action) {
      case "mark":
        dispatch(markSuccess(date, habit));
        break;
      case "unmark":
        dispatch(unmarkSuccess(date, habit));
        break;
      case "skip":
      case "autoskip":
        dispatch(skipSuccess(date, habit, habitDates));
        break;
      default:
        console.warn("Unknown pending action:", action);
    }

    // Update streak for all actions
    dispatch(updateStreak(habit.id));
  }

  clearPendingActions();
}
